<template>
  <div class="goods" :class="list.bgColor">
    <div class="wrapper">
      <div class="goods-img">
        <img :src="list.img">
      </div>
      <div class="goods-body">
        <h3>{{list.title}}</h3>
        <p class="goods-body-info">
          {{list.info}}
        </p>
        <div class="goods-body-select">
          <span class="label">
            选择类型 : 
          </span>
          <span class="option" @click="active($event)">企业宣传</span>
          <span class="option" @click="active($event)">应用功能</span>
        </div>
        <p class="goods-body-price">￥{{list.price}}</p>
        <router-link to="/mall/pay" tag="div" class="goods-body-buy">
          立即购买
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default({
  props: ['list'],
  methods: {
    active: function (e) {
      let dom = e.srcElement
      // 通过有没有该类名判定是否加class
      if (dom.className.indexOf('op-active') >= 0) {
        e.srcElement.classList.remove('op-active')
        } else {
        e.srcElement.classList.add('op-active')
      }
    }
  }
})
</script>

<style scoped>
.active {
  background-color: #fff;
}
.op-active {
  background-color: #fff !important;
  color: #ff574e;
  border: 1px solid #ff574e;
}
.wrapper {
  width: 58%;
  height: 470px;
  margin: 0 auto;
  display: flex;
  transition: all .6s ease;
}
.goods-img {
  display: flex;
  align-items: center;
  min-width: 243px;
}
.goods-img > img{
  width: 100%;
  transition: width .6s ease;
}
.goods-body {
  font-size: 100px;
  margin-left: 110px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  transition: margin .6s ease;
  min-width: 316px;
}
.goods-body h3 {
  font-size: .34em;
}
.goods-body-info {
  font-size: .22em;
  text-align: justify;
  color: #939393;
  padding: 20px 0;
}
.goods-body-select {
  color: #939393; 
}
.label {
  font-size: 22px;
}
.option {
  background-color: #f1eeee;
  font-size: 18px;
  padding: 12px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 6px;
  transition: all .2s ease;
}
.goods-body-price {
  font-size: .36em;
  color: #ff574e;
  padding: 30px 0;
  transition: padding .6s ease;
}
.goods-body-buy {
  font-size: .24em;
  background-color: #ff574e;
  color: #ffffff;
  width: 158px;
  text-align: center;
  line-height: 46px;
  border-radius: 4px;
  cursor: pointer;
}
.goods-body-buy:hover {
  box-shadow: 0 0 20px 1px #ffc9c9;
}

@media (max-width: 1199px) {
  .goods-body {
    font-size: 80px;
    margin-left: 50px;
  }
  .goods-body-price {
    padding: 10px 0;
  }
}
@media (max-width: 991px) and (min-width: 801px){
  .wrapper {
    width: 80%;
    height: 400px;
  }
}
@media screen and (max-width: 801px){
  .wrapper {
    width: 100%;
    height: 400px;
    position: relative;
  }
  .goods-body {
    margin-left: 0;
    padding: 20px;
  }
  .goods-img {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mall/slot/goodsSlot.vue